import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import PopupModal from '../PopupModal/PopupModal.js';

var ToolTipPopUpModal = (_param)=>{
    var { className , toolTip , isPhone  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "toolTip",
        "isPhone"
    ]);
    var ref, ref1;
    const image = isPhone ? toolTip === null || toolTip === void 0 ? void 0 : (ref = toolTip.image) === null || ref === void 0 ? void 0 : ref.mobile : toolTip === null || toolTip === void 0 ? void 0 : (ref1 = toolTip.image) === null || ref1 === void 0 ? void 0 : ref1.original;
    var ref2, _description;
    return /*#__PURE__*/ React.createElement(PopupModal, swcHelpers.extends({}, rest, {
        className: classnames('tool-tip-popup-modal', className),
        title: (ref2 = toolTip === null || toolTip === void 0 ? void 0 : toolTip.title) !== null && ref2 !== void 0 ? ref2 : '',
        showIcon: true
    }), toolTip && /*#__PURE__*/ React.createElement(React.Fragment, null, toolTip.image && /*#__PURE__*/ React.createElement("img", {
        className: "tool-tip-popup-modal__image",
        src: image === null || image === void 0 ? void 0 : image.url,
        alt: (_description = toolTip.image.description) !== null && _description !== void 0 ? _description : undefined
    }), /*#__PURE__*/ React.createElement("div", {
        className: "tool-tip-popup-modal__content",
        dangerouslySetInnerHTML: {
            __html: toolTip.description.value
        }
    })));
};
var ToolTipPopUpModal$1 = ToolTipPopUpModal;

export { ToolTipPopUpModal, ToolTipPopUpModal$1 as default };
//# sourceMappingURL=ToolTipPopUpModal.js.map
